import { Injectable } from "@angular/core";
import { Observable, catchError, retry } from "rxjs";

import {
	PerfilViewModel,
	PoliticaViewModel,
} from "../models/admin/perfil.model";
import { ApiEnum, HttpDataService } from "./http-data.service";

/**
 * Gestión del sistema Perfil + Política (RBAC de aplicación).
 * Rutas relativas invariantes entre entornos; la base la resuelve ApiEnum.API_ROOT.
 */
@Injectable({ providedIn: "root" })
export class PerfilService {
	private readonly base = "/Perfil";

	constructor(private readonly httpDataService: HttpDataService) {}

	getPerfiles(): Observable<PerfilViewModel[]> {
		return this.httpDataService
			.get$<PerfilViewModel[]>(ApiEnum.API_ROOT, this.base)
			.pipe(retry(2), catchError(this.httpDataService.handleError<PerfilViewModel[]>("getPerfiles")));
	}

	getPoliticas(): Observable<PoliticaViewModel[]> {
		return this.httpDataService
			.get$<PoliticaViewModel[]>(ApiEnum.API_ROOT, `${this.base}/Politicas`)
			.pipe(retry(2), catchError(this.httpDataService.handleError<PoliticaViewModel[]>("getPoliticas")));
	}

	getPerfilesByUsuario(usuarioId: number): Observable<PerfilViewModel[]> {
		return this.httpDataService
			.get$<PerfilViewModel[]>(ApiEnum.API_ROOT, `${this.base}/Usuario/${usuarioId}`)
			.pipe(catchError(this.httpDataService.handleError<PerfilViewModel[]>("getPerfilesByUsuario")));
	}

	asignarPerfil(usuarioId: number, perfilId: number, ambito?: string): Observable<unknown> {
		return this.httpDataService.post$<unknown>(ApiEnum.API_ROOT, `${this.base}/Usuario`, {
			usuarioId,
			perfilId,
			ambito: ambito ?? null,
		});
	}

	quitarPerfil(usuarioId: number, perfilId: number): Observable<unknown> {
		return this.httpDataService.delete$<unknown>(
			ApiEnum.API_ROOT,
			`${this.base}/Usuario/${usuarioId}/${perfilId}`,
		);
	}

	crearPerfil(perfil: PerfilViewModel): Observable<number> {
		return this.httpDataService.post$<number>(ApiEnum.API_ROOT, this.base, perfil);
	}

	actualizarPerfil(perfil: PerfilViewModel): Observable<unknown> {
		return this.httpDataService.put$<unknown>(ApiEnum.API_ROOT, this.base, perfil);
	}
}
